import React, { useEffect, useState } from 'react';
import { Upload, message } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import './ProfilePictureUpload.css'

function ProfilePictureUpload(props) {
  const [avatarBase64, setAvatarBase64] = useState(null);
  const [loading, setLoading] = useState(false);

  // Accept only image files
  const acceptImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp'];
  const handleChange = (info) => {
    setAvatarBase64("");
    setLoading(true);
    
    // Check if the uploaded file is an image
    const isImage = info.file.type.startsWith('image/');
    
    if (isImage) {
      // If it's an image, continue processing
      props.imageFile(info);
      
      setTimeout(() => {
        const reader = new FileReader();
        reader.onload = (e) => {
          setAvatarBase64(e.target.result);
          setLoading(false);
        };
        reader.readAsDataURL(info.file);
      }, 500);
    } else {
      // If it's not an image, show an error message
      message.error('Please upload a valid image file (JPEG, PNG, GIF).');
      setLoading(false);
    }
  };
  
  const uploadButton = (
    <div className="custom-upload-button" 
    style={{ width: 100, height: 250 }}>
      {loading ? <LoadingOutlined style={{ marginTop: 100 }}/> : <PlusOutlined style={{ marginTop: 100 }}/>}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  useEffect(() => {
    if(props.imageUrl !== "" || props.imageUrl !== undefined){
      setAvatarBase64(props.imageUrl)
    }
  }, [props.imageUrl])

  return (
    <Upload
      name="avatar"
      listType="picture-card"
      className="avatar-uploader"
      showUploadList={false}
      action="/your-upload-endpoint"
      accept={acceptImageTypes.join(',')}
      maxCount={1} // Allow only one file to be uploaded
      beforeUpload={() => false} // To prevent immediate upload
      onChange={handleChange}
    >
      {avatarBase64 ? (
        <img src={avatarBase64} alt="avatar" style={{ width: '100%' }} />
      ) : (
        uploadButton
      )}
    </Upload>
  );
}

export default ProfilePictureUpload;
